import { useState } from "react";
import { ISection } from "./ISection";
import s from './Section.module.css'
import cn from 'classnames'
import Image from 'next/image'
import Question from "../question";

const Section: ISection = ({ icon, title, description, questions, preShown }) => {
    const [isSelected, setIsSelected] = useState(preShown);
    const [isSelectedMobile, setIsSelectedMobile] = useState(preShown);

    const questionList = questions.map(quest => Question(quest));

    const handleSelect = () => {
        if (!isSelected) {
            setIsSelected(true);
        }
    }
    const handleMobileSelect = () =>{
        setIsSelectedMobile(!isSelectedMobile)
    }

    const unSelect = () => {
        setIsSelected(false);
    }
    const getSelector = (unselectors: Array<() => void>) => {
        return <li
        key = {title}
            onClick={() => {
                handleSelect();
                unselectors.forEach(uns=>{uns()})
            }}
            className={cn(s.selector,
                { [s.active]: isSelected }
            )}
        >
            <div
                className={cn(s.selectorImage)}
            >
                {icon}
            </div>
            <span>
                <strong>
                {title}
                </strong>
            </span>
            <span>
                {description}
            </span>
        </li>
    }

    const getSection = <div
    key = {`section_${title}`}
        className={cn({ [s.hide]: !isSelected })}
    >
        <div className={cn(s.header,
            {[s.activeHeader] : isSelectedMobile}
        )}
            onClick={handleMobileSelect}
        >
            <div className={cn(s.headerIcon)}>
                {icon}
            </div>
            <div>
                <span>
                    <strong>
                        {title}
                    </strong>
                </span>
                <br></br>
                <span>
                    {description}
                </span>
            </div>
        </div>
        <div
            className={cn(s.questions,
                { [s.mobileExpand]: isSelectedMobile }
            )}
        >
            {
                questionList.map(question => question)
            }
        </div>
    </div>

    return {
        getSelector,
        getSection,
        unSelect
    }
}

export default Section;